import { isEmea, isFlight } from 'utils/dcContext'

export enum Grade {
  'A_GRADE',
  'B_GRADE',
  'C_GRADE',
  'S_GRADE',
  'HASH'
}

export const getSimpleGrade = (grade: Grade | string): string => {
  switch (grade) {
    case 'A_GRADE':
      return 'A'
    case 'B_GRADE':
      return 'B'
    case 'C_GRADE':
      return 'C'
    case 'S_GRADE':
      return 'S'
    case 'HASH':
      return 'HASH'
    default:
      return grade as string
  }
}

export const toGrade = (grade: string): string => {
  switch (grade) {
    case 'A':
      return 'A_GRADE'
    case 'B':
      return 'B_GRADE'
    case 'C':
      return 'C_GRADE'
    case 'S':
      return 'S_GRADE'
    case 'HASH':
      return 'HASH'
    default:
      return grade
  }
}

export const getSimpleGrades = (): string[] => {
  return isEmea || isFlight ? ['A', 'B', 'C', 'S', 'HASH'] : ['A', 'B', 'C', 'HASH']
}
